import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useRef } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import swal from "sweetalert";
import firepadRef from "../../../../../../../src/VideoChatContents/server/firebase";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import "./AddMeetUp.css";

var room_id = firepadRef.key;

const AddMeetUp = () => {
  const history = useHistory();
  const [starList, setStarList] = useState([]);
  const [eventType, setEventType] = useState("Online");
  const [convertedContent, setConvertedContent] = useState("");
  const [instruction, setInstruction] = useState("");
  const [loading, setLoading] = useState(false);

  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'meetup/images',delKey);


  const [meetupInput, setMeetup] = useState({
    event_name: "",
    event_link: "",
    star_id: "",
    event_date: "",
    start_time: "",
    end_time: "",
    venue: "",
    total_seat: "",
    reg_start_date: "",
    reg_end_date: "",
    fee: "",
    error_list: [],
  });

  const handleChange = (event) => {
    setEventType(event.target.value);
  };
  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const handleInput = (e) => {
    e.persist();
    setMeetup({ ...meetupInput, [e.target.name]: e.target.value });
  };

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const meetupSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const fData = new FormData();

    fData.append("banner", fileKey);
    fData.append("title", meetupInput.event_name);
    fData.append("meetup_type", eventType);
    fData.append("star_id", meetupInput.star_id);
    fData.append("event_date", meetupInput.event_date);
    fData.append("start_time", meetupInput.start_time);
    fData.append("end_time", meetupInput.end_time);
    fData.append("description", convertedContent);
    fData.append("instruction", instruction);
    if (eventType === "Online") {
      fData.append("event_link", room_id);
    }
    fData.append("venue", meetupInput.venue);
    fData.append("total_seat", meetupInput.total_seat);
    fData.append("reg_start_date", meetupInput.reg_start_date);
    fData.append("reg_end_date", meetupInput.reg_end_date);
    fData.append("fee", meetupInput.fee);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/add_meetup`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push(`/superstar-admin/meetup-events/pending`);

          socket.current.emit("meetup_approve", {
            id: res.data.meetup_id,
          });
        } else {
          setMeetup({
            ...meetupInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 ">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Create Meetup</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  action=""
                  onSubmit={meetupSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row mb-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Select Super Star</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={meetupInput.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger">
                        {meetupInput.error_list?.star_id}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Event Type</>
                      </p>
                    </div>
                    <div className="col-md-9 ">
                      <div className="">
                        <select
                          className="form-control reply-control"
                          aria-label="Default select example"
                          value={eventType}
                          onChange={handleChange}
                        >
                          <option value="Online">Online</option>
                          <option value="Offline">Offline</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Event Name</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        placeholder="Enter event Name"
                        type="text"
                        onChange={handleInput}
                        name="event_name"
                        value={meetupInput.event_name}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.title}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data=""
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.description}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Instruction</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data=""
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.instruction}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Event Date</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="event_date"
                        value={meetupInput.event_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.event_date}
                      </small>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 my-2 label-text">
                      <p>
                        <>From </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-control"
                        type="time"
                        onChange={handleInput}
                        name="start_time"
                        value={meetupInput.start_time}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.start_time}
                      </small>
                    </div>

                    <div className="col-md-3 my-2 label-text text-center">
                      <p>
                        <>To </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-control"
                        type="time"
                        onChange={handleInput}
                        name="end_time"
                        value={meetupInput.end_time}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.end_time}
                      </small>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 my-2 label-text">
                      <p>
                        <>Registration Start</>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="reg_start_date"
                        value={meetupInput.reg_start_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.reg_start_date}
                      </small>
                    </div>

                    <div className="col-md-3 my-2 label-text text-center">
                      <p>
                        <>To </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="reg_end_date"
                        value={meetupInput.reg_end_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.reg_end_date}
                      </small>
                    </div>
                  </div>

                  {eventType === "Offline" ? (
                    <div className="row my-4">
                      <div className="col-md-3 label-text">
                        <p>
                          <>Venue</>
                        </p>
                      </div>
                      <div className="col-md-9">
                        <input
                          className="form-control reply-control me-4"
                          type="text"
                          onChange={handleInput}
                          name="venue"
                          value={meetupInput.venue}
                        />
                        <small className="text-danger">
                          {meetupInput.error_list?.venue}
                        </small>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Slots</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        placeholder="Enter slots"
                        type="number"
                        onChange={handleInput}
                        name="total_seat"
                        value={meetupInput.total_seat}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.total_seat}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Upload Banner</>
                      </p>
                    </div>
                    <div className="col-md-6">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src my-2"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      ) : (
                        ""
                      )}

                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleImageChange(e.target.files)}
                        id="image"
                        name="image"
                        accept="image/*"
                      />
                    {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Fee</>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <input
                        className="form-control reply-control"
                        type="number"
                        onChange={handleInput}
                        placeholder="Enter fee $"
                        name="fee"
                        min={0}
                        value={meetupInput.fee}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.fee}
                      </small>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMeetUp;
